import { StyleSheet } from "react-native";
import spacing from "./spacing";
import colors from "./colors";

const getFontStyles = mdColors => {
  return StyleSheet.create({
    regular: {
      fontSize: 16,
      lineHeight: 24,
      color: mdColors.text
    },
    heading: {
      fontWeight: "500",
      color: mdColors.text
    }
  });
};

const getStyles = (userStyles, colorScheme, userTheme) => {
  const mdColors = { ...colors[colorScheme || "light"],
    ...(userTheme === null || userTheme === void 0 ? void 0 : userTheme.colors)
  };
  const mdSpacing = { ...spacing,
    ...(userTheme === null || userTheme === void 0 ? void 0 : userTheme.spacing)
  };
  const fontStyle = getFontStyles(mdColors);
  return StyleSheet.create({
    em: StyleSheet.flatten([fontStyle.regular, {
      fontStyle: "italic"
    }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.em]),
    strong: StyleSheet.flatten([fontStyle.regular, {
      fontWeight: "bold"
    }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.strong]),
    strikethrough: StyleSheet.flatten([fontStyle.regular, {
      textDecorationLine: "line-through",
      textDecorationStyle: "solid"
    }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.strikethrough]),
    text: StyleSheet.flatten([fontStyle.regular, userStyles === null || userStyles === void 0 ? void 0 : userStyles.text]),
    paragraph: StyleSheet.flatten([fontStyle.regular, {
      paddingVertical: mdSpacing.m
    }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.paragraph]),
    link: StyleSheet.flatten([fontStyle.regular, {
      fontStyle: "italic",
      color: mdColors.link
    }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.link]),
    blockquote: StyleSheet.flatten([{
      borderLeftColor: mdColors.border,
      paddingLeft: mdSpacing.l,
      borderLeftWidth: mdSpacing.s,
      opacity: 0.8
    }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.blockquote]),
    h1: StyleSheet.flatten([fontStyle.heading, {
      fontSize: 32,
      lineHeight: 40,
      fontWeight: "bold",
      marginVertical: mdSpacing.m,
      letterSpacing: 0,
      paddingBottom: mdSpacing.s,
      borderBottomColor: mdColors.border,
      borderBottomWidth: 1
    }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.h1]),
    h2: StyleSheet.flatten([fontStyle.heading, {
      fontSize: 28,
      lineHeight: 36,
      marginVertical: mdSpacing.m,
      paddingBottom: mdSpacing.s,
      borderBottomColor: mdColors.border,
      borderBottomWidth: 1
    }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.h2]),
    h3: StyleSheet.flatten([fontStyle.heading, {
      fontSize: 24,
      lineHeight: 32,
      marginVertical: mdSpacing.s
    }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.h3]),
    h4: StyleSheet.flatten([fontStyle.heading, {
      fontSize: 22,
      lineHeight: 28,
      marginVertical: mdSpacing.s
    }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.h4]),
    h5: StyleSheet.flatten([fontStyle.regular, fontStyle.heading, {
      marginVertical: mdSpacing.xs
    }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.h5]),
    h6: StyleSheet.flatten([fontStyle.heading, {
      fontSize: 14,
      lineHeight: 20,
      marginVertical: mdSpacing.xs
    }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.h6]),
    codespan: StyleSheet.flatten([fontStyle.regular, {
      fontStyle: "italic",
      backgroundColor: mdColors.code,
      fontWeight: "300"
    }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.codespan]),
    code: StyleSheet.flatten([{
      padding: mdSpacing.l,
      backgroundColor: mdColors.code,
      minWidth: "100%"
    }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.code]),
    hr: StyleSheet.flatten([{
      borderBottomWidth: 1,
      borderBottomColor: mdColors.border,
      marginVertical: mdSpacing.s
    }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.hr]),
    li: StyleSheet.flatten([fontStyle.regular, {
      flexShrink: 1
    }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.li]),
    image: StyleSheet.flatten([{
      resizeMode: "cover"
    }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.image]),
    table: StyleSheet.flatten([{
      borderWidth: 1,
      borderColor: mdColors.border
    }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.table]),
    tableRow: StyleSheet.flatten([{
      flexDirection: "row"
    }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.tableRow]),
    tableCell: StyleSheet.flatten([{
      padding: mdSpacing.s
    }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.tableCell])
  });
};

export default getStyles;
//# sourceMappingURL=styles.js.map